<script>
	  import { createEventDispatcher } from 'svelte';

    export let type = 'button';
    export let primary = false;
    export let raised = false;
    let className = "";
    let styleDef = "";

    export {className as class};
    export {styleDef as style};

	  const dispatch = createEventDispatcher();
	  const submit = () => dispatch('submit');
</script>


 <button on:click={submit} 
        class:bg-main={primary}
        class:border={raised}
        class:border-main={raised}
        class:font-bold ={primary}
        class:text-white={primary} 
        class="hover:opacity-75 z-0 py-2 lg:px-4 px-2 rounded-md focus:outline-none focus:shadow-outline leading-5 font-medium transition duration-150 ease-in-out {className}" 
        type="{type}"
        style="{styleDef}">        
          <slot></slot>
</button>